import React from 'react';
import { AnimatedSection } from './AnimatedSection';
interface PageHeroProps {
  label?: string;
  title: React.ReactNode;
  subtitle?: string;
  children?: React.ReactNode;
}
export function PageHero({
  label,
  title,
  subtitle,
  children
}: PageHeroProps) {
  return <section className="relative pt-40 pb-24 lg:pt-48 lg:pb-32 overflow-hidden" style={{
    background: 'linear-gradient(135deg, #0D0D0D 0%, #112845 45%, #1A4E82 100%)'
  }} data-id="element-166">
      {/* Heavy dark overlay — much darker */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'rgba(0,0,0,0.72)'
    }} data-id="element-167" />

      {/* Dot grid */}
      <div className="absolute inset-0 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.13) 1px, transparent 1px)',
      backgroundSize: '36px 36px',
      maskImage: 'linear-gradient(to bottom right, transparent 0%, black 30%, black 85%, transparent 100%)',
      WebkitMaskImage: 'linear-gradient(to bottom right, transparent 0%, black 30%, black 85%, transparent 100%)'
    }} data-id="element-168" />

      {/* Decorative rings */}
      <div className="absolute pointer-events-none" style={{
      right: '-160px',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '640px',
      height: '640px',
      borderRadius: '50%',
      border: '1px solid rgba(255,255,255,0.10)'
    }} data-id="element-169" />
      <div className="absolute pointer-events-none" style={{
      right: '-80px',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '440px',
      height: '440px',
      borderRadius: '50%',
      border: '1px solid rgba(255,255,255,0.07)'
    }} data-id="element-170" />
      <div className="absolute pointer-events-none" style={{
      right: '0px',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '260px',
      height: '260px',
      borderRadius: '50%',
      border: '1px solid rgba(255,255,255,0.05)'
    }} data-id="element-171" />

      {/* Sky-blue glow */}
      <div className="absolute pointer-events-none" style={{
      top: '-60px',
      right: '8%',
      width: '500px',
      height: '500px',
      borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(60,130,220,0.22) 0%, transparent 70%)',
      filter: 'blur(60px)'
    }} data-id="element-172" />

      {/* Thin bottom separator */}
      <div className="absolute bottom-0 left-0 right-0 pointer-events-none" style={{
      height: '1px',
      background: 'linear-gradient(to right, transparent, rgba(183,164,131,0.25), transparent)'
    }} data-id="element-173" />

      {/* Content */}
      <div className="max-w-[1440px] w-full mx-auto px-6 lg:px-12 relative z-10" data-id="element-174">
        <AnimatedSection className="max-w-3xl" data-id="element-175">
          {label && <span className="text-accent font-semibold tracking-wider uppercase mb-4 block text-sm" data-id="element-176">
              {label}
            </span>}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-light text-white leading-tight tracking-tight mb-6" data-id="element-177">
            {title}
          </h1>
          {subtitle && <p className="text-lg font-light leading-relaxed" style={{
          color: 'rgba(200,215,235,0.80)'
        }} data-id="element-178">
              {subtitle}
            </p>}
          {children}
        </AnimatedSection>
      </div>
    </section>;
}